var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 17.2222C20 18.7567 18.7567 20 17.2222 20H2.77778C1.24389 20 0 18.7567 0 17.2222V2.77778C0 1.24333 1.24389 0 2.77778 0H17.2222C18.7567 0 20 1.24333 20 2.77778V17.2222Z",
    fill: "#324F96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 7.22483H6.11176V16.6693H3.33398V7.22483ZM4.71454 6.11372H4.69898C3.8701 6.11372 3.33398 5.49594 3.33398 4.72427C3.33398 3.93594 3.88676 3.33594 4.73065 3.33594C5.57565 3.33594 6.09621 3.93594 6.11176 4.72427C6.11176 5.49538 5.57565 6.11372 4.71454 6.11372ZM16.6673 16.6693H13.8895V11.6143C13.8895 10.3932 13.209 9.55983 12.1162 9.55983C11.2823 9.55983 10.8312 10.122 10.6123 10.6654C10.5323 10.8598 10.5562 11.3976 10.5562 11.6693V16.6693H7.77843V7.22483H10.5562V8.67816C10.9568 8.05816 11.584 7.22483 13.1884 7.22483C15.1762 7.22483 16.6668 8.47483 16.6668 11.2659L16.6673 16.6693Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.b0b3cea3f9923a40e2f6d00ad0472a2f.svg";
export { ForwardRef as ReactComponent };